/* @flow */

import { compose } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import {
  getEventName,
  getEventLogo,
  hasEventCustomBraindateName,
  getEventNavbarSponsors,
} from '@e180/domain/lib/event/util';

import EventBrandingDumb from './EventBrandingDumb';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  variant: any,
  // Self passed
  intl: intlShape,
};

const mapStateToProps = (state: State, { variant, intl }: Props): Object => {
  const { locale } = intl;
  const event = getEventSafely(state);
  const navbarSponsors = getEventNavbarSponsors(event);

  return {
    variant,
    name: getEventName(event, locale),
    logo: getEventLogo(event),
    hasCustomBraindateName: hasEventCustomBraindateName(event, locale),
    hasSponsors: navbarSponsors && navbarSponsors.length > 0,
  };
};

// Make variants available
export * from './EventBrandingDumb';

export default compose(injectIntl, connect(mapStateToProps))(EventBrandingDumb);
